class DiscountCodePurchaseLimit {
  None() {
    return 0;
  }
  AllPurchasesAllowed() {
    return 1;
  }
  FirstPurchaseOnly() {
    return 2;
  }
  ExtendOnly() {
    return 3;
  }
  ReturningCustomerOnly() {
    return 4;
  }
}
export default new DiscountCodePurchaseLimit();
